import React from 'react';

import useWindowSize from 'hooks/use-windowSize';
import { useQuery } from 'react-query';
import { CartMetaDataService } from 'services/payments';

import CartMeta from './CartMeta';
import CartPayment from './CartPayment';

import classes from './CartDetails.module.scss';

const CartDetails = ({ refetchCart }) => {
	const { mobileDevice } = useWindowSize();
	const { data: cartMetaData, refetch: refetchMetaData } = useQuery(['cart-meta'], () =>
		CartMetaDataService()
	);
	return (
		<>
			<div className={`${classes['cart-details']}`}>
				<CartMeta cartMetaData={cartMetaData?.data} refetchMetaData={refetchMetaData} />
				<CartPayment
					cartMetaData={cartMetaData?.data}
					refetchMetaData={refetchMetaData}
					mobileDevice={mobileDevice}
					refetchCart={refetchCart}
				/>
			</div>
		</>
	);
};

export default CartDetails;
